import React, {useContext, useEffect} from 'react';
import {Link} from 'react-router-dom'
import {useForm} from "react-hook-form";

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box'
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import CircularProgress from '@mui/material/CircularProgress';
import { DataGrid } from '@mui/x-data-grid';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import dayjs from 'dayjs';
// import utc from 'dayjs/plugin/utc';

import * as RestCall from '../../utils/network/RestCalls';
import * as CustomStyles from '../styles/CustomStyles';
import * as Security from '../../utils/auth/Security';
import BucketContext from '../context/BucketContext';
import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';
import * as Consts from '../constants/Consts';
import * as TypeConvertor from '../util/TypeConvertor';
import CustomSelect from '../custom/CustomSelectComponent'
import * as SelectTypes from '../constants/CustomSelectTypes'
import { EeAuthzType } from '../constants/Consts';
import ReportAuthzIscir from './ReportAuthzIscirComponent';
import ReportAuthzInternal from './ReportAuthzInternalComponent';

// dayjs.extend(utc);


// const columns = [
//     {
//         field: 'cnp',
//         headerName: 'CNP',
//         width: 150,
//         valueGetter: (params) => params.row.cnp,
//         renderCell: (params) => {
//             return(
//                 <Link to={`/employees/${params.row.employeeId}?employerId=${params.row.employerId}`}>
//                     {params.row.cnp}
//                 </Link>
//             );
//         }
//     },
//     {
//         field: 'lastName',
//         headerName: 'Nume',
//         width: 150,
//         valueGetter: (params) => params.row.lastName
//     },
//     {
//         field: 'firstName',
//         headerName: 'Prenume',
//         width: 150,
//         valueGetter: (params) => params.row.firstName
//     },
//     {
//         field: 'ocupatiaCOR',
//         headerName: 'Ocupatia (COR)',
//         width: 300,
//         valueGetter: (params) => params.row.occupationCORdescription
//     },
//     {
//         field: 'authzNo',
//         headerName: 'Nr. Autorizatie',
//         width: 200,
//         valueGetter: (params) => params.row.authNo
//     },
//     {
//         field: 'authzDate',
//         headerName: 'Data Autorizatie',
//         width: 120,
//         valueGetter: (params) => params.row.dataAutorizatie ? params.row.rdataAutorizatie : '',
//         renderCell: (params) => {
//             return( Formatter.formatDatetoRO(params.row.dataAutorizatie) );
//         }
//     },
//     {
//         field: 'authzType',
//         headerName: 'Tip Autorizatie',
//         width: 200,
//         valueGetter: (params) => TypeConvertor.getAuthzIscirName(params.row.authISCIR)
//     },
//     {
//         field: 'talonNo',
//         headerName: 'Serie Talon',
//         width: 200,
//         valueGetter: (params) => params.row.talonSeria
//     },
//     {
//         field: 'talonDate',
//         headerName: 'Data Talon',
//         width: 120,
//         valueGetter: (params) => params.row.dataEliberareTalon ? params.row.dataEliberareTalon : '',
//         renderCell: (params) => {
//             return( Formatter.formatDatetoRO(params.row.dataEliberareTalon) );
//         }
//     },
//     {
//         field: 'talonExpiryDate',
//         headerName: 'Scadenta Talon',
//         width: 120,
//         valueGetter: (params) => params.row.dataScadentaTalon ? params.row.dataScadentaTalon : '',
//         renderCell: (params) => {
//             return(
//                 <Typography variant="body2" color={getDateTextColor(params.row.dataScadentaTalon)}>
//                     {Formatter.formatDatetoRO(params.row.dataScadentaTalon)}
//                 </Typography>
//             );
//         }
//     },
//     {
//         field: 'stampLastDate',
//         headerName: 'Data Ultima Viza',
//         width: 120,
//         valueGetter: (params) => params.row.stampLastDate ? params.row.stampLastDate : '',
//         renderCell: (params) => {
//             return( Formatter.formatDatetoRO(params.row.stampLastDate) );
//         }
//     },
//     {
//         field: 'stampExpiryDate',
//         headerName: 'Scadenta Viza',
//         width: 120,
//         valueGetter: (params) => params.row.stampExpiryDate ? params.row.stampExpiryDate : '',
//         renderCell: (params) => {
//             return( 
//                 <Typography variant="body2" color={getDateTextColor(params.row.stampExpiryDate)}>
//                     {Formatter.formatDatetoRO(params.row.stampExpiryDate)}
//                 </Typography>
                 
//             );
//         }
//     },
//     {
//         field: 'courseRegDate',
//         headerName: 'Data Inscriere la Curs',
//         width: 200,
//         valueGetter: (params) => params.row.courseDate ? params.row.courseDate : '',
//         renderCell: (params) => {
//             return( Formatter.formatDatetoRO(params.row.courseDate) );
//         }
//     },
//     {
//         field: 'statusEmployee',
//         headerName: 'Status Angajat',
//         width: 200,
//         valueGetter: (params) => TypeConvertor.getCimStatusName(params.row.employeeContractStatus)
//     },

// ]

// const referencefDate = dayjs().format('YYYY-MM-DD');


// const getDateTextColor = (dateToDisplay) => {
//     var textColor = "text.primary";


//     if(dateToDisplay) {
//         if( referencefDate.localeCompare(dateToDisplay.substring(0,10)) <= 0) {
//             textColor = "text.primary";
//         }
//         else {
//             textColor = "error.main";
//         }
//     }

//     return textColor;
// }

const fetchReport = async (reportType, authzType, workSiteId) => {
    const ddbReport = await RestCall.fetchReport(reportType, authzType, workSiteId)
        .catch(error => console.log(error));    

    return ddbReport;
}

function RsvtiReports(props) {
    console.log('___RsvtiReports___');
    const bucketContext = useContext(BucketContext);

    const {handleSubmit, formState: { errors, defaultValues }} = useForm();

    useEffect(() => {
        props.loadComponentData();
    }, []);

 
    var contextClientId = '';
    if( !!bucketContext.bucket.userContext?.clientId && props.clients.status === ReduxDataStatus.SUCCEEDED ){
        contextClientId = bucketContext.bucket.userContext.clientId != Consts.COREVO_CLIENT_ID ? bucketContext.bucket.userContext.clientId : '';
    }

    const clientSelectData = TypeConvertor.getClientSelectData(props.clients.clients);
    const [selectedClientId, setSelectedClientId] = React.useState( contextClientId );

    const handleClientChange = (clientId) => {
        setSelectedClientId(clientId);
        bucketContext.setBucketValue({userContext: {clientId: clientId}});
    }

    const employerSelectData = TypeConvertor.getEmployerSelectData(props.employers);
    // const sEmployer = employerSelectData.length > 0 ? employerSelectData[0].id : '';
    var sEmployer;
    if(!!bucketContext.bucket?.employeeFilter?.employerId)
        sEmployer = bucketContext.bucket.employeeFilter.employerId;
    else if(employerSelectData.length > 0)
        sEmployer = employerSelectData[0].id;
    else
        sEmployer = '';


    const worksiteSelectData = TypeConvertor.getWorksiteSelectData(sEmployer, props.worksites, false);
    const sWorksite = worksiteSelectData.length >0 ? worksiteSelectData[0].id : '';

    const [selectedEmployerId, setSelectedEmployerId] = React.useState( sEmployer );
    const [selectedWorksiteId, setSelectedWorksiteId] = React.useState( sWorksite );
    const [selectedAuthzType, setSelectedAuthzType] = React.useState( EeAuthzType.Iscir );

    const handleEmployerChange = (employerId) => {
        setSelectedEmployerId(employerId);
        setSelectedWorksiteId('');
        bucketContext.setBucketValue({employeeFilter: {employerId: employerId, worksiteId: -1, occupations: [], occupationsCod:[], expanded: true}});
    }

    const handleWorksiteChange = (worksiteId) => {
        setSelectedWorksiteId(worksiteId);
    }

    const [report, setReport] = React.useState([]);
    const [isFetchingReport, setIsFetchingReport] = React.useState(false);
    const [reportEmployerName, setReportEmployerName] = React.useState('');
    const [reportWorksiteName, setReportWorksiteName] = React.useState([]);
    const [reportAuthzType, setReportAuthzType] = React.useState('');

    const handleFetchReport = async () => {
        console.log('Handle Fetch Report' );

        setReportEmployerName( TypeConvertor.getSelectItemDescription(selectedEmployerId, employerSelectData) );
        setReportWorksiteName( TypeConvertor.getSelectItemDescription(selectedWorksiteId, worksiteSelectData) );
        setReportAuthzType( selectedAuthzType );

        setIsFetchingReport(true);
        const ddbReport = await fetchReport('WS_DESERVENTI', selectedAuthzType, selectedWorksiteId);
        setIsFetchingReport(false);

        setReport(ddbReport);
    }

    // const downloadRaport = () => {
    //     console.log('download');

    //     var csv_data = generateCsvData();

    //     // Create CSV file object and feed our
    //     // csv_data into it
    //     const CSVFile = new Blob([csv_data], { type: "text/csv" });
    
    //     // Create to temporary link to initiate
    //     // download process
    //     var temp_link = document.createElement('a');
    
    //     // Download csv file
    //     temp_link.download = "Raport-" + reportWorksiteName.replace(/ /g, "-").replace(/,/g, "") + ".csv";
    //     var url = window.URL.createObjectURL(CSVFile);
    //     temp_link.href = url;
    
    //     // This link should not be displayed
    //     temp_link.style.display = "none";
    //     document.body.appendChild(temp_link);
    
    //     // Automatically click the link to trigger download
    //     temp_link.click();
    //     document.body.removeChild(temp_link);        
    // }

    // const generateCsvData = () => {

    //     var csv_data = [];
    //     const csvEmpty = ['', '', '', '', '', '', '', '', '', '', '', '', '', ''];
    //     const csvHeader = ['CNP', 'Nume', 'Prenume', 'Ocupatia (COR)', 'Nr. Autorizatie', 'Data Autorizatie', 'Tip Autorizatie', 'Serie Talon', 'Data Talon', 'Scadenta Talon', 'Data Ultima Viza', 'Scadenta Viza', 'Data Inscriere la Curs', 'Status Anggajat'];
        
    //     csv_data.push(csvEmpty.join(","));                 // Combine each column value with comma

    //     var employerLine = ['Nume Angajator', reportEmployerName];
    //     csv_data.push(employerLine.join(","));

    //     var worksiteLine = ['Punct de lucru', reportWorksiteName];
    //     csv_data.push(worksiteLine.join(","));

    //     var reportDateLine = ['Data Raport', Formatter.formatDatetoRO(dayjs().format())];
    //     csv_data.push(reportDateLine.join(","));

    //     csv_data.push(csvEmpty.join(",")); 
    //     csv_data.push(csvEmpty.join(",")); 

    //     // Combine each column value with comma
    //     csv_data.push(csvHeader.join(","));    

    //     for (var i = 0; i < report.length; i++) {
    //         const reportLine = report[i];

    //         var csvRow = [];
    //         csvRow.push(reportLine.cnp);
    //         csvRow.push(reportLine.lastName);
    //         csvRow.push(reportLine.firstName);
    //         csvRow.push(reportLine.occupationCORdescription);
    //         csvRow.push(reportLine.authNo);
    //         csvRow.push( Formatter.formatDatetoRO(reportLine.dataAutorizatie) );
    //         csvRow.push(TypeConvertor.getAuthzIscirName(reportLine.authISCIR));
    //         csvRow.push(reportLine.talonSeria);
    //         csvRow.push( Formatter.formatDatetoRO(reportLine.dataEliberareTalon) );
    //         csvRow.push( Formatter.formatDatetoRO(reportLine.dataScadentaTalon) );
    //         csvRow.push( Formatter.formatDatetoRO(reportLine.stampLastDate) );
    //         csvRow.push( Formatter.formatDatetoRO(reportLine.stampExpiryDate) );
    //         csvRow.push( Formatter.formatDatetoRO(reportLine.courseDate) );
    //         csvRow.push(TypeConvertor.getCimStatusName(reportLine.employeeContractStatus));

    //         csv_data.push(csvRow.join(",")); 
    //     }
    //     csv_data.push(csvEmpty.join(",")); 

    //     // combine each row data with new line character
    //     csv_data = csv_data.join('\n');    

    //     return csv_data;

    // }





    // if (props.equipment.isLoading) { 
    //     return(
    //         <Container maxWidth="xl" >
    //         <Box px={{xs: 3, sm: 7}}>
    //             <Loading />
    //         </Box>
    //         </Container>
    //     );
    // }
    // else { 
        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>

                <Stack spacing={1} sx={{marginBottom: 2}}>
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                            <Link to="/home">Acasa</Link>
                            <Typography color="text.primary">Rapoarte</Typography>
                        </Breadcrumbs>
                    </Box>

                    <hr />

                    <form id='rsvtiReportForm' onSubmit={ (event) => {
                                                        event.stopPropagation(); 
                                                        return false;
                                                    }}
                    >
                    <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                        {/*row*/}
                        <Grid item xs={4}>
                            {Security.isSystemUser() ?
                                <FormControl fullWidth size="small" margin="dense" variant="standard">
                                    <InputLabel id={'daAngajator-inputLabelId'}>Client</InputLabel>
                                    <Select
                                        labelId={'daClient-selectLabelId'}
                                        id={'daClient'}
                                        value={selectedClientId}
                                        onChange={(event) => handleClientChange(event.target.value) } 
                                        label={'daClient-label'}
                                    >
                                        {
                                            clientSelectData.map((data) => <MenuItem dense value={data.id} key={data.id}> {data.name} </MenuItem>)
                                        }
                                    </Select>
                                </FormControl>
                                    :
                                <React.Fragment></React.Fragment>
                            }
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                        {/*row*/}
                        <Grid item xs={4}>
                            <FormControl fullWidth size="small" margin="dense" variant="standard">
                                <InputLabel id={'daAngajator-inputLabelId'}>Angajator</InputLabel>
                                <Select
                                    labelId={'daAngajator-selectLabelId'}
                                    id={'daAngajator'}
                                    value={selectedEmployerId}
                                    onChange={(event) => handleEmployerChange(event.target.value) } 
                                    label={'daAngajator-label'}
                                >
                                    {
                                        employerSelectData.map((data) => <MenuItem dense value={data.id} key={data.id}> {data.name} </MenuItem>)
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl fullWidth size="small" margin="dense" variant="standard">
                                <InputLabel id={'daWorkSite-inputLabelId'}>Punct de Lucru</InputLabel>
                                <Select
                                    labelId={'daWorkSite-selectLabelId'}
                                    id={'daWorkSite'}
                                    value={selectedWorksiteId}
                                    onChange={(event) => handleWorksiteChange(event.target.value)}
                                    label={'daWorkSite-label'}
                                >
                                    {
                                        worksiteSelectData.map((data) => <MenuItem dense value={data.id} key={data.id}> {data.name} </MenuItem>)
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}>
                            <Box display="flex" justifyContent="flex-end" alignItems="flex-end">
                                <Button variant="outlined" type="submit" name="Fetch" sx={{ marginRight: 1 }} onClick={handleSubmit( handleFetchReport )} disabled={isFetchingReport}> 
                                    {isFetchingReport && <CircularProgress size={25} />}
                                    {!isFetchingReport && 'Genereaza Raport'}
                                </Button>
                            </Box>
                        </Grid>

                        {/*row*/}
                        <Grid item xs={4}>
                            <CustomSelect 
                                selectId={'aaType'}
                                callback={setSelectedAuthzType}
                                selectType={SelectTypes.ANGAJAT_AUTORIZAT_TYPES} 
                                value={selectedAuthzType}
                            />
                        </Grid>
                        <Grid item xs={8}>
                        </Grid>

                    </Grid>
                    </form>

                    <br/>
                    {/* <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                        <Grid item xs={4}>
                            <Typography color="text.primary">Nume Angajator</Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography color="text.primary">{reportEmployerName}</Typography>
                        </Grid>

                        <Grid item xs={4}>
                            <Typography color="text.primary">Punct de lucru</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography color="text.primary">{reportWorksiteName}</Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Box display="flex" justifyContent="flex-end" alignItems="flex-end">
                                <Link onClick={() => downloadRaport()}>Salveaza Raport<FileDownloadIcon /></Link>
                            </Box>
                        </Grid>
                    </Grid> */}

                    {/* <Box sx={{ height: 650, width: '100%', marginTop: 2, marginBottom: 2  }}>
                        <DataGrid
                            rows={report}
                            columns={columns}
                            initialState={{
                                sorting: { sortModel: [{ field: 'lastName', sort: 'asc' }] }
                            }}                            
                            sx={{ overflowX: 'scroll' }}
                            pageSize={10}
                            rowsPerPageOptions={[10]}
                            checkboxSelection={false}
                            disableSelectionOnClick
                            experimentalFeatures={{ newEditingApi: true }}
                        />
                    </Box> */}
                    { reportAuthzType === EeAuthzType.Iscir ?
                        <ReportAuthzIscir 
                            report = {report}
                            reportEmployerName = {reportEmployerName}
                            reportWorksiteName = {reportWorksiteName}
                        />
                            :
                        <ReportAuthzInternal 
                            report = {report}
                            reportEmployerName = {reportEmployerName}
                            reportWorksiteName = {reportWorksiteName}
                        />
                    }
                </Stack>

            </Box>
            </Container>
        );
    // }
}

export default RsvtiReports;